import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-layout-session',
	templateUrl: './layout-session.component.html'
})
export class LayoutSessionComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
